import { linkTargetResolver } from '@mntn-dev/app-routing'
import { Feed } from '@mntn-dev/ui-components'
import { ActivityContainer } from '../activity-container.tsx'
import { ActivityTrans } from '../activity-trans.tsx'
import { Link } from '../link.tsx'
import type { ActivityDetailsProps } from './types.ts'

export const PreProductionBrandFeedbackSubmitted = ({
  activity,
  activity: {
    activityId,
    actor,
    details: {
      activityType,
      data: { approved, target },
    },
  },
  t,
  onNavigate,
  currentUrl,
}: ActivityDetailsProps<'pre_production_brand_feedback_submitted'>) => (
  <ActivityContainer {...{ activity }}>
    <Feed.Summary>
      <ActivityTrans
        t={t}
        i18nKey={`${activityType}.approved.${approved}.summary`}
        values={{
          subject: actor.displayName,
          service: target.service,
        }}
      />
    </Feed.Summary>
    <Feed.Annotations>
      <Feed.Tag
        type={approved ? 'success' : 'error'}
        dataTestId={`activity-feed-item-${activityId}-status-tag`}
        dataTrackingId={`activity-feed-item-${activityId}-status-tag`}
      >
        {t(`${activityType}.approved.${approved}.status`)}
      </Feed.Tag>
      <Link
        {...{
          target: linkTargetResolver['project-service']({ target }),
          t,
          onNavigate,
          currentUrl,
          dataTestId: `activity-feed-item-${activityId}-view-project-link`,
          dataTrackingId: `activity-feed-item-${activityId}-view-project-link`,
        }}
      />
    </Feed.Annotations>
  </ActivityContainer>
)
